import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Modal } from 'react-bootstrap';
import { API_URL_All } from '../../api';
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import axiosInstance from '../../axiosInstance';

const TransferSackCode = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);
  const [model, setModel] = useState({});
  const [modelDetails, setModelDetails] = useState({});
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [showOrderDetailForm, setShowOrderDetailForm] = useState(false);

  useEffect(() => {
    initializeData(data);
  }, [data]);

  const clearUrlParam = () => {
    const hash = window.location.hash;

    if (hash.includes('?')) {
      const cleanHash = hash.split('?')[0];
      const newUrl = window.location.origin + window.location.pathname + cleanHash;
      window.history.replaceState(null, '', newUrl);
    }
  }
  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    clearUrlParam();
    window.dispatchEvent(new Event('refresh-operation-info'));
    setShow(false);
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    var dataModel = { ...model };

    try {
      var requestApi = `/api/import-orders/transferSackCode`;
      const response = await axiosInstance.post(requestApi, dataModel);
      if (!response.data.success) {
        general.showFormError('.show .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      if (handleSearch) handleSearch();
      handleModalClose();
      
    } catch (error) {
      toast.error(error.message);
    }

  };

  const handleSubmitFormOrderDetail = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    var dataModel = { ...modelDetails, 
      detailIds: data.detailIds ,
      listIds: []
    };
    console.log(dataModel);
    

    try {
      var requestApi = `/api/import-orders/transferSackCode`;
      const response = await axiosInstance.post(requestApi, dataModel);
      if (!response.data.success) {
        general.showFormError('.show .modal-body', response.data);
        return;
      }
      toast.success(response.data.message);
      if (handleSearch) handleSearch();
      handleModalClose();
      
    } catch (error) {
      toast.error(error.message);
    }

  };

  const initializeData = async (obj) => {
    var orderId = obj.id;
    const isNumber = Number.isFinite(orderId);
    if (!isNumber) {
      orderId = 0;
    }

    const idsText = obj.listIds.join(';');
    const detailIdsText = obj.detailIds.join(';');
    var urlApi = `/api/import-orders/searchTransferOrders?size=500&orderIds=${idsText}`;
    var urlApiDetails = `/api/import-orders/searchTransferOrderDetails?size=500&detailsIds=${detailIdsText}`;
    if (obj.requesterId) {
      urlApi = `/api/import-orders/searchTransferOrders?size=500&requesterId=${obj.requesterId}`;
    }

    setModel({});
    setModelDetails({});
    setShowOrderForm(false);
    setShowOrderDetailForm(false);
    try {
      var response = await axiosInstance.get(urlApi);
      var obj = response.data;
      var responseDetails = await axiosInstance.get(urlApiDetails);
      var objDetails = responseDetails.data;

      setModel(obj);
      setModelDetails(objDetails);
      
      // Check if API response has data and set form visibility
      if (obj?.page?.content && obj.page.content.length > 0) {
        setShowOrderForm(true);
      }
      if (objDetails?.page?.content && objDetails.page.content.length > 0) {
        setShowOrderDetailForm(true);
      }
      
      setShow(true);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };
   
  return (
    <Modal show={show} onHide={handleModalClose} size="lg">
      <div className="">
        {showOrderForm && <form id="order_editor_form" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {model.orderCode && (<span className="record_id">Code: {model.orderCode}</span>)}
              <div>
                <h5 className="modal-title">Cập nhật mã bao cho đơn hàng</h5>
                {model.error && (
                  <div className="error-msg-server">{model.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body mt-2">

              <div className="row">
                <div className="col-md-8 mb-3">

                  <div className="group-box p-0" data-text="Danh sách đơn hàng">


                    <section className="p-1 pt-4">
                      <div className="table-responsive border table-normal table-sticky">
                        <table className="table table-striped border-normal table-bordered">
                          <thead className="table-primary head-01">
                            <tr>
                              <th className='sticky text-center' width="21px"></th>

                              <th className="text-center"><span>Ngày</span></th>
                              <th className="text-center">Mã bao</th>
                              <th className="text-center">Mã vận đơn TQ</th>
                              <th className="text-center"><span>Mã Khách hàng</span></th>
                              <th>Tên đơn hàng</th>

                            </tr>
                          </thead>
                          {model.page && model.page.content && model.page.content.map((item, index) => (
                            <tbody className="tbody-row">
                              <tr key={index}>
                                <td className='sticky text-center' title={`orderCode: ${item.orderCode}`}>
                                  {index + 1}
                                </td>
                                <td className="text-success text-center" title={item.lineName}>{general.formatDate2(item.createdDate)}</td>
                                <td className="text-success text-center">{item.sackCode}</td>
                                <td className="text-success text-center">{item.cnShippingCode}</td>
                                <td className='text-success text-center'>{item.customerCode}</td>
                                <td className="text-success text-start">{item.name}</td>

                              </tr>
                            </tbody>
                          ))}

                        </table>
                      </div>
                    </section>
                  </div>

                </div>
                <div className="col-md-4 mb-3">
                  <div>
                    <label className="form-label required">Mã bao</label>
                    <div className="">
                      <input type="text" className="form-control" name="sackCode" placeholder="Nhập mã bao..." data-required="Phải nhập mục này." value={model.sackCode ?? ''} onChange={(e) => setModel({ ...model, sackCode: e.target.value })} />
                    </div>
                  </div>
                </div>


              </div>


            </div>
            <div className="modal-footer justify-content-between">
              <div>
              </div>
              <button type="submit" className="btn-sm btn btn-primary">Cập nhật</button>
            </div>
          </div>
        </form>
        }
        
        {showOrderDetailForm && <form id="order_detail_editor_form" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitFormOrderDetail}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {modelDetails.orderCode && (<span className="record_id">Code: {modelDetails.orderCode}</span>)}
              <div>
                <h5 className="modal-title">Cập nhật mã bao cho chi tiết đơn hàng - Line VAT</h5>
                {modelDetails.error && (
                  <div className="error-msg-server">{modelDetails.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body mt-2">

              <div className="row">
                <div className="col-md-8 mb-3">

                  <div className="group-box p-0" data-text="Danh sách đơn hàng">


                    <section className="p-1 pt-4">
                      <div className="table-responsive border table-normal table-sticky">
                        <table className="table table-striped border-normal table-bordered">
                          <thead className="table-primary head-01">
                            <tr>
                              <th className='sticky' width="21px"></th>

                              <th><span>Ngày</span></th>
                              <th>Mã bao</th>
                              <th>Mã vận đơn TQ</th>
                              <th><span>Mã Khách hàng</span></th>
                              <th>Tên đơn hàng</th>

                            </tr>
                          </thead>
                          {modelDetails.page && modelDetails.page.content && modelDetails.page.content.map((item, index) => (
                            <tbody className="tbody-row">
                              <tr key={index}>
                                <td className='sticky' title={`orderCode: ${item.orderCode}`}>
                                  {index + 1}
                                </td>
                                <td className="text-success" title={item.lineName}>{general.formatDate2(item.createdDate)}</td>
                                <td className="text-success text-start">{item.sackCode}</td>
                                <td className="text-success text-start">{item.cnShippingCode}</td>
                                <td className='text-success text-start'>{item.customerCode}</td>
                                <td className="text-success text-start">{item.name}</td>

                              </tr>
                            </tbody>
                          ))}

                        </table>
                      </div>
                    </section>
                  </div>

                </div>
                <div className="col-md-4 mb-3">
                  <div>
                    <label className="form-label required">Mã bao</label>
                    <div className="">
                      <input type="text" className="form-control" name="sackCode" placeholder="Nhập mã bao..." data-required="Phải nhập mục này." value={modelDetails.sackCode ?? ''} onChange={(e) => setModelDetails({ ...modelDetails, sackCode: e.target.value })} />
                    </div>
                  </div>
                </div>


              </div>


            </div>
            <div className="modal-footer justify-content-between">
              <div>
              </div>
              <button type="submit" className="btn-sm btn btn-primary">Cập nhật</button>
            </div>
          </div>
        </form>
        }
      </div>
    </Modal>
  );
};

export default TransferSackCode;
